import React, { Component } from 'react'

export class Services extends Component {  
  render() {    
  
    return (        
        // <!-- Choose Us Start -->
        <div className="section techwix-choose-us-section section-padding" style={{backgroundImage: `url(${process.env.PUBLIC_URL}/images/choose-us-bg.jpg)` }}>
            <div className="container">
                {/* <!-- Choose Us Wrap Start --> */}
                <div className="choose-us-wrap">
                    <div className="section-title text-center">
                        <h3 className="sub-title">REASON TO CHOOSE US</h3>
                        <h2 className="title">We provide truly prominent Web solutions.</h2>
                    </div>
                    <div className="choose-us-content-wrap">
                        <div className="row">
                          {
                            this.props.allservices?
                            this.props.allservices.map((item, i) =>                              
                               <div key={item.service_name} className="col-lg-4 col-md-6">
                                {/* <!-- Choose Us Item Start --> */}
                                <a href={item.more_info_link}>
                                <div className="choose-us-item">
                                    <div className="choose-us-img">
                                        <img src={item.service_image.toString()} alt="" />
                                        <div className="choose-us-content">
                                            <h3 className="title">{item.service_name}</h3>
                                            <p>{item.service_content}</p>
                                        </div>
                                    </div>
                                </div>
                                {/* <!-- Choose Us Item End --> */}
                                </a>
                            </div>
                            )
                            :''
                          }
                        </div>                        
                    </div>
                </div>
                {/* <!-- Choose Us Wrap End --> */}
            </div>
        </div>
        // <!-- Choose Us End --> 
    )
  }
}

export default Services